import gql from 'graphql-tag';
import { newsFeedNewsFragment } from './news-feed-news-item.fragment';

export const createUpdateNewsMutation = gql`
  mutation createUpdateNews($newsId: String, $news: NewsInput!) {
    createUpdateNews(newsId: $newsId, news: $news) {
      ...NewsFields
    }
  }

  ${newsFeedNewsFragment}
`;
